import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center container-x" data-testid="page-404">
      <div className="text-center max-w-lg">
        <div className="eyebrow text-gold">Errore 404</div>
        <h1 className="font-serif text-5xl md:text-7xl mt-4">Pagina non trovata.</h1>
        <p className="mt-6 text-taupe font-light">
          La pagina che stavi cercando non esiste più o è stata spostata. Torna alla home o esplora i percorsi di consulenza.
        </p>
        <div className="mt-8 flex gap-3 justify-center flex-wrap">
          <Link to="/" className="btn-ink">Torna alla Home</Link>
          <Link to="/servizi" className="btn-outline-ink">Vedi i Servizi</Link>
        </div>
      </div>
    </div>
  );
}
